function showMoreServices() {
  const showMoreButton = document.getElementById('showMoreServices');
  const hiddenServices = document.getElementsByClassName('col-hidden-services');

  if (showMoreButton) {
    showMoreButton.addEventListener('click', function () {
      showMoreButton.classList.add('is-hidden');
      hiddenServices.forEach(function (item) {
        item.classList.remove('is-hidden');
      });
    });
  }
}
